import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

interface ContainerProps {
  $isSelected: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;

  inline-size: 100%;
  block-size: 51px;
  padding-block: 0;
  padding-inline: 20px 16px;

  border: 1px solid#bbbbbb;
  border-radius: 30px;

  background: ${props => (props.$isSelected ? "#FFCA05" : "#FFFFFF")};

  cursor: pointer;
`;

export const PackagesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  margin-block: 20px;
  margin-inline: 0;
`;

export const Image = styled.img`
  inline-size: 23px;
  block-size: 23px;
`;

export const Text = styled.div`
  display: -webkit-box;
  flex: 1;

  margin-block: 0;
  margin-inline: 10px;

  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

export const IconSelect = styled.div`
  inline-size: 24px;
  block-size: 24px;

  border-radius: 100%;

  background: #ececec;
`;
